module.exports = __webpack_public_path__ + "static/img/anxun21.ab3349a0.png";